import { getIsUnplannedReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { WIR } from 'types/wellGuardian';

import { getReactiveStepKeys, getStepKeys } from './getStepKeys';

export const getPhases = (wir: WIR | null, country: string) => {
  if (getIsUnplannedReactiveScope(wir)) {
    return getReactiveStepKeys(country);
  } else {
    return getStepKeys(country);
  }
};
